import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=36a9814b&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=36a9814b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a9814b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36a9814b')) {
      api.createRecord('36a9814b', component.options)
    } else {
      api.reload('36a9814b', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=36a9814b&scoped=true&", function () {
      api.rerender('36a9814b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2msWMPHKHxG88/JS/comp/Voucher.vue"
export default component.exports